import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PATH } from '@app/constants';
import { User } from '@app/models';
import { PipesModule } from '@app/pipes';
import { CountUpModule } from 'ngx-countup';

@Component({
  selector: 'mnf-dashboard-v2-summary-cards',
  standalone: true,
  imports: [RouterModule, CountUpModule, PipesModule],
  providers: [CurrencyPipe],
  templateUrl: './dashboard-v2-summary-cards.component.html',
  styleUrl: './dashboard-v2-summary-cards.component.scss'
})
export class DashboardV2SummaryCardsComponent implements OnChanges {
  @Input() user: User;
  @Input() profitUser: { beneficio_no_referred: number, beneficio_referred: number, rendimientos: number }
  invested: string;
  balance: string;
  totalInvested: string;
  totalEarnings: number;
  path = PATH;
  constructor(private currency: CurrencyPipe){}

  ngOnChanges(changes: SimpleChanges): void {
   if(changes['user'] && this.user){
       const balance = this.currency.transform(
         this.user?.wallet?.balance,
       )
       
       this.balance = balance
          ?.split('.')
          ?.map((n,i) => (i === 0 ? n : `${n}`))
          ?.join('.');

       const total = this.user?.participations?.reduce(
          (p, c) => p + c.partValue * c.amount,
          0
       );

      this.totalInvested = `${this.currency
         ?.transform((Number(this.user?.wallet?.balance) || 0) + total)
         ?.split('.')
         ?.map((n,i) => (i === 0 ? n : `${n}`))
         ?.join('.')}`;

      this.invested = `${this.currency.transform(
        this.user?.participations?.reduce(
          (p, c) => p + (c.amount * Number(c.partValue)), 
          0))}`;
   }
   if (changes['profitUser'] && this.profitUser) {
      this.totalEarnings = this.profitUser?.beneficio_no_referred + this.profitUser?.beneficio_referred + this.profitUser?.rendimientos;
   }
  }
}